import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const BRANCH_CREATE_RESOURCE = "branch" as const;
export const BRANCH_CREATE_API_PATH = `/v1/${BRANCH_CREATE_RESOURCE}` as const;

export type BranchCreateBody =
  paths[typeof BRANCH_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type BranchCreateResponse =
  paths[typeof BRANCH_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useBranchCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<BranchCreateResponse, Error, BranchCreateBody>({
    mutationFn: async (application: BranchCreateBody) => {
      const response = await alphartisApiAxios.post<BranchCreateResponse>(BRANCH_CREATE_API_PATH, application);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [BRANCH_CREATE_RESOURCE, "search"],
      });
    },
  });
};
